import { render, staticRenderFns } from "./EmployeeBranding.vue?vue&type=template&id=0e5444f8&scoped=true"
import script from "./EmployeeBranding.vue?vue&type=script&lang=js"
export * from "./EmployeeBranding.vue?vue&type=script&lang=js"
import style0 from "./EmployeeBranding.vue?vue&type=style&index=0&id=0e5444f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5444f8",
  null
  
)

export default component.exports